import axios from 'axios'
import {
  Modal,
  DatePicker,
  Table,
  message
} from 'ant-design-vue';
import qs from 'qs'
import router from '@/router'
import Vue from "vue";
// 172.30.176.23
// const api = process.env.NODE_ENV != 'production' ? '/api' : '/api'
const api = process.env.NODE_ENV != 'production' ? '' : ''
// const api = process.env.NODE_ENV != 'production' ? '172.30.176.10:7352' : '/api'
let baseURL = ''
if (process.env.NODE_ENV != 'production') {
  // baseURL = api + '/newymapi'
  baseURL = api
} else {
  baseURL = api
}

const Axios = axios.create({
  baseURL: baseURL, // 请求后台地址
  timeout: 60000,
  responseType: 'json',
  withCredentials: true, // 是否允许带cookie这些
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

// POST传参序列化(添加请求拦截器)
Axios.interceptors.request.use(
  config => {
    if(config.headers['Content-Type'].search('application/json')==-1){
      config.data = qs.stringify(config.data)
    }

    // 在发送请求之前做某件事
    // Vue.prototype.$Loading.service()
    return config
  },
  error => {
    // error 的回调信息
    // Vue.prototype.$Loading.close()
    // Message({
    //   //  饿了么的消息弹窗组件,类似toast
    //   showClose: true,
    //   message: ,
    //   type: 'error'
    // })
    // message.error('您没有进入该页面的权限,请联系管理员')
    return Promise.reject(error.data.error.message)
  }
)

// 返回状态判断(添加响应拦截器)
Axios.interceptors.response.use(
  res => {
    // 若token失效或已经过期，则返回登录页
    // Vue.prototype.$Loading.close()

    if(res.headers&&res.headers.total){
      sessionStorage.setItem('pdftotal',res.headers.total)
    }
    if ((res && res.data && (res.data.msg == 'You have not logged in yet!' || res.data.msg === "You have not logged in yet!" || res.data.msg === "This account has been logged in elsewhere, for this login session will be terminated." || res.data.msg === 'Please login first'))) {
      // error 的回调信息
      let num=sessionStorage.getItem('intercepterTime')
      if( num===null ){
        message.error(res.data.msg)
        setTimeout(() => {
          router.push({
            path: '/login'
          })
        }, 50)
        sessionStorage.setItem('intercepterTime',1)
      }else{
        setTimeout(() => {
          router.push({
            path: '/login'
          })
        }, 50)
      }
    } else {
      if (res.data && res.data.flag == 'success') {
        return res && res.data
      } else {
        // message.error(res.data.msg)
        return res && res.data
      }
    }
  },
  error => {
    // 返回 response 里的错误信息
    // Vue.prototype.$Loading.close()
    let errorInfo = error.message
      ? error.message
      : error.data.error
        ? error.data.error.message
        : error.data
    // Message({
    //   showClose: true,
    //   message: errorInfo,
    //   type: 'error'
    // })
    return Promise.reject(errorInfo)
  }
)
export default Axios



// WEBPACK FOOTER //
// ./src/util/request/request.js